module.exports = __webpack_public_path__ + "static/media/C6.89cdc690.jpg";